import React from 'react';
import styled from 'styled-components';
import { COLORS, SIZES, Typography } from '@fupa/fupa-uikit';
const StyledTypography = styled(Typography).withConfig({
  componentId: "sc-oubh12-0"
})(["&&&{color:", ";padding:", " ", " ", ";min-height:3rem;margin:0;display:inline-flex;justify-content:space-between;align-items:center;}"], COLORS.darkerGrey, SIZES['12'], SIZES['16'], SIZES['8']);
export default function SectionHeading(_ref) {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledTypography, {
    variant: "subheading2",
    "data-sentry-element": "StyledTypography",
    "data-sentry-component": "SectionHeading",
    "data-sentry-source-file": "SectionHeading.tsx"
  }, children);
}